/*
 * LSF 21/09/2026 — PERF
 *
 * 1) Les prix « barres » du tiroir etaient recuperes avec des XMLHttpRequest
 *    SYNCHRONES (`xhr.open(..., false)`), une par ligne de panier, en serie.
 *    Le thread principal etait gele a chaque ouverture du tiroir et a chaque
 *    clic +/-. Remplace par des fetch() paralleles + cache memoire.
 *
 * 2) CartDrawerItems.onCartUpdate() heritait de CartItems et allait chercher
 *    `/cart?section_id=main-cart-items` (la section 42 Ko de l'ANCIENNE page
 *    panier) pour injecter son HTML dans le tiroir. Requete inutile ET mauvaise
 *    cible. Surcharge ci-dessous : on ne refait rien si le tiroir vient d'etre
 *    re-rendu par product-form, sinon on recharge la bonne section.
 */

/* --- Cache memoire des produits (partage avec cart.js) --- */
var LSF_PRODUCT_CACHE = (window.LSF_PRODUCT_CACHE =
  window.LSF_PRODUCT_CACHE || {});

function lsfFetchProduct(handle) {
  if (!LSF_PRODUCT_CACHE[handle]) {
    LSF_PRODUCT_CACHE[handle] = fetch(`/products/${handle}.js`)
      .then(response => (response.ok ? response.json() : null))
      .catch(() => null);
  }
  return LSF_PRODUCT_CACHE[handle];
}

/* Renvoie une Promise vers un tableau des compare_at_price, aligne sur items */
function lsfCompareAtPrices(items) {
  return Promise.all(items.map(item => lsfFetchProduct(item.handle))).then(products =>
    products.map((product, i) => {
      if (!product || !product.variants) return 0;
      const variant = product.variants.find(v => v.id == items[i].variant_id);
      return variant && variant.compare_at_price ? variant.compare_at_price : 0;
    })
  );
}

/* Barre de progression « plus que X € ». Le Liquid la rend vide (largeur 0,
   montant vide) : elle est entierement peinte par JavaScript. Extraite ici
   pour etre rejouee a chaque re-rendu du tiroir, pas seulement a l'ouverture. */
function lsfPaintShippingBar(cartData) {
  document.querySelectorAll('.drawer__module--free_shipping').forEach(shippingBar => {
    const before = shippingBar.querySelector('.free-shipping__left-amount');
    const after = shippingBar.querySelector('.free-shipping__success');
    const amount = shippingBar.querySelector('.free-shipping__amount');
    const drag = shippingBar.querySelector('.free-shipping__drag');
    if (!before || !after || !drag) return;

    const current = cartData.total_price / 100;
    const target = shippingBar.dataset.target;

    if (target - current > 0) {
      if (amount) {
        amount.textContent = new Intl.NumberFormat(document.body.dataset.shopLocale, {
          style: 'currency',
          currency: document.body.dataset.shopCurrency,
        }).format(target - current);
      }
      before.classList.remove('hidden');
      after.classList.add('hidden');
      drag.style.width = `${(current * 100) / target}%`;
    } else {
      after.classList.remove('hidden');
      before.classList.add('hidden');
      drag.style.width = '100%';
    }
  });
}

/* Calcule et applique les totaux du tiroir (prix barres, economies, total) */
function lsfUpdateCartTotals() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => lsfCompareAtPrices(cartData.items).then(compareAts => ({ cartData, compareAts })))
    .then(({ cartData, compareAts }) => {
      let totalSavings = 0;
      let indexItems = 1;

      const fmt = value =>
        new Intl.NumberFormat(document.body.dataset.shopLocale, {
          style: 'currency',
          currency: document.body.dataset.shopCurrency,
        }).format(value);

      cartData.items.forEach((item, idx) => {
        let itemCompareAtPrice = compareAts[idx] || 0;
        const itemPrice = item.original_line_price / item.quantity;

        const priceEl = document.querySelector(`.priceWrapper${indexItems}`);
        const linePriceEl = document.querySelector(`.linePriceWrapper${indexItems}`);
        indexItems++;

        const canRender = !!(priceEl && linePriceEl);
        const showSale = canRender && item.original_price <= item.final_price;

        const saleLabel = canRender ? priceEl.dataset.salePrice : '';
        const regularLabel = canRender ? priceEl.dataset.regularPrice : '';

        const onSaleHTML = (was, now) => `
              <div class="cart-item__discounted-prices">
                <span class="visually-hidden">${saleLabel}</span>
                <s class="cart-item__old-price product-option">${was}</s>
                <span class="visually-hidden">${regularLabel}</span>
                <strong class="cart-item__final-price product-option">${now}</strong>
              </div>
            `;

        if (itemCompareAtPrice == null || itemCompareAtPrice < 1) {
          totalSavings += item.line_level_total_discount;
          if (showSale) {
            priceEl.innerHTML = `<div class="product-option">${fmt(itemPrice / 100)}</div>`;
            linePriceEl.innerHTML = `<span class="product-option">${fmt((itemPrice * item.quantity) / 100)}</span>`;
          }
        } else if (itemCompareAtPrice > itemPrice) {
          const itemTotalCompareAtPrice = item.quantity * itemCompareAtPrice;
          totalSavings += itemTotalCompareAtPrice - item.original_line_price + item.line_level_total_discount;
          if (showSale) {
            priceEl.innerHTML = onSaleHTML(fmt(itemCompareAtPrice / 100), fmt(itemPrice / 100));
            linePriceEl.innerHTML = onSaleHTML(
              fmt((itemCompareAtPrice * item.quantity) / 100),
              fmt((itemPrice * item.quantity) / 100)
            );
          }
        } else if (showSale) {
          priceEl.innerHTML = `<div class="product-option">${fmt(itemPrice / 100)}</div>`;
          linePriceEl.innerHTML = `<span class="product-option">${fmt((itemPrice * item.quantity) / 100)}</span>`;
        }
      });

      const subTotalEl = document.querySelector('.drawer__subtotal--amount');
      const savingsEl = document.querySelector('.drawer__savings--amount');
      const totalEl = document.querySelector('.drawer__total--amount');

      if (subTotalEl) {
        const row = document.querySelector('.totals.subtotal');
        if (totalSavings > 0) {
          subTotalEl.textContent = fmt((cartData.total_price + totalSavings) / 100);
          if (row) row.style.display = 'flex';
        } else if (row) {
          row.style.display = 'none';
          const next = document.querySelector('.totals.subtotal + *');
          if (next) next.style.marginTop = '0';
        }
      }

      if (savingsEl) {
        const row = document.querySelector('.totals.savings');
        if (totalSavings > 0) {
          savingsEl.textContent = '-' + fmt(totalSavings / 100);
          if (row) row.style.display = 'flex';
        } else if (row) {
          row.style.display = 'none';
          const next = document.querySelector('.totals.savings + *');
          if (next) next.style.marginTop = '0';
        }
      }

      if (totalEl) totalEl.textContent = fmt(cartData.total_price / 100);

      lsfPaintShippingBar(cartData);
    })
    .catch(e => console.error(e));
}

/* LSF 23/09/2026 — Hydratation du tiroir.
   Le HTML du tiroir est reinjecte par trois chemins differents :
   CartDrawer.renderContents() (ajout au panier), CartDrawerItems.onCartUpdate()
   et la couche « bon d'achat » de lsf-mobile-ux.js. Or le Liquid ne sait rendre
   ni le sous-total, ni les economies, ni les prix barres : ce sont des
   marqueurs « ... » remplis apres coup par JavaScript. Le carrousel
   « Complétez votre commande » doit lui aussi etre reinstancie, sans quoi
   Swiper laisse ses slides hors du cadre et le bloc parait vide.
   Sans ce passage groupe, le tiroir restait fige sur « ... » au sous-total,
   perdait les prix barres et masquait l'upsell des le premier re-rendu. */
window.lsfDrawerHydrate = function () {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawer.launchUpsellSlider();
    drawer.launchTrustSlider();
  }
  return lsfUpdateCartTotals();
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', evt => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    const goToCheckoutReducedBtns = document.querySelectorAll('.cartDiscountCodeButton');
    if (goToCheckoutReducedBtns) {
      goToCheckoutReducedBtns.forEach(goToCheckoutReducedBtn => {
        goToCheckoutReducedBtn.addEventListener('click', () => {
          this.handlePromoCode(goToCheckoutReducedBtn);
        });
      });
    }
  }

  handlePromoCode(el) {
    const theDiscount = document.getElementById(el.dataset.input).value;
    const toRedirect = `/checkout?discount=${theDiscount}`;
    window.location.href = toRedirect;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', event => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.classList.add('animate', 'active');

    this.launchTimer();
    this.launchTrustSlider();
    this.launchUpsellSlider();

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.item_count === 0) {
          this.hideAllModules();
          if (localStorage.getItem('storyThemeDrawerTimer')) localStorage.removeItem('storyThemeDrawerTimer');
        }

        const shippingBars = document.querySelectorAll('.drawer__module--free_shipping');
        if (shippingBars) {
          shippingBars.forEach(shippingBar => {
            const before = shippingBar.querySelector('.free-shipping__left-amount');
            const after = shippingBar.querySelector('.free-shipping__success');
            const amount = shippingBar.querySelector('.free-shipping__amount');
            const drag = shippingBar.querySelector('.free-shipping__drag');
            const current = cart.total_price / 100;
            const target = shippingBar.dataset.target;
            const formattedAmount = new Intl.NumberFormat(document.body.dataset.shopLocale, {
              style: 'currency',
              currency: document.body.dataset.shopCurrency,
            }).format(target - current);

            if (target - current > 0) {
              amount.textContent = formattedAmount;
              before.classList.remove('hidden');
              after.classList.add('hidden');
              drag.style.width = `${(current * 100) / target}%`;
            } else {
              after.classList.remove('hidden');
              before.classList.add('hidden');
              drag.style.width = '100%';
            }
          });
        }
      });

    lsfUpdateCartTotals();

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
  }

  hideAllModules() {
    document.querySelectorAll('.drawer__module').forEach(module => (module.style.display = 'none'));
  }

  launchTrustSlider() {
    const el = document.querySelector('#drawer-trust__swiper');
    if (!el) return;

    /* Meme precaution que pour l'upsell : cette methode est desormais rejouee
       a chaque re-rendu du tiroir, et un autoplay en loop non detruit continue
       de tourner sur un element detache. */
    if (el.swiper) el.swiper.destroy(true, true);

    const trustDrawerCartSlider = new Swiper(el, {
      autoplay: { delay: 1000 },
      loop: true,
      navigation: {
        nextEl: '.button-next-drawer-trust__swiper',
        prevEl: '.button-prev-drawer-trust__swiper',
      },
    });
  }

  launchUpsellSlider() {
    const el = document.querySelector('#drawer-upsell__swiper');
    if (!el) return;

    /* LSF 21/09/2026 — Bug upsell mobile.
       Le tiroir est re-rendu a chaque ajout au panier, puis open() est
       rappele : sans destroy(), plusieurs instances Swiper s'empilaient sur
       le meme element avec des options divergentes (1.2 ici, 1.3 dans
       cart.js). Les translations calculees ne correspondaient plus a la
       largeur reelle des slides, donc les cartes suivantes partaient hors
       du overflow:hidden et leur bouton « Ajouter » devenait inatteignable. */
    if (el.swiper) el.swiper.destroy(true, true);

    /* slidesPerView:'auto' laisse Swiper lire la largeur imposee par le CSS
       (#CartDrawer .drawer__upsell .swiper-slide { width:86% !important })
       au lieu d'en recalculer une concurrente. */
    const upsellDrawerCartSlider = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      autoHeight: true,
    });

    /* Les vignettes sont en loading="lazy" : mesurees avant chargement,
       autoHeight retombe a une hauteur nulle et rogne les cartes. */
    el.querySelectorAll('img').forEach(img => {
      if (!img.complete) {
        img.addEventListener('load', () => upsellDrawerCartSlider.update(), { once: true });
      }
    });
  }

  launchTimer() {
    if (document.querySelector('.drawer__module--timer')) {
      const timer = document.querySelector('.drawer__module--timer-time');
      const timerDrawerModule = document.querySelector('.drawer__module--timer');
      let time;

      if (localStorage.getItem('storyThemeDrawerTimer')) {
        time = localStorage.getItem('storyThemeDrawerTimer');
      } else {
        time = timerDrawerModule.dataset.duration * 60;
        localStorage.setItem('storyThemeDrawerTimer', time);
      }

      const tick = () => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        timer.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;

        if (time > 0) {
          localStorage.setItem('storyThemeDrawerTimer', time--);
        } else {
          const xhr = new XMLHttpRequest();
          xhr.open('POST', '/cart/clear.js', true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              localStorage.removeItem('storyThemeDrawerTimer');
              window.location.reload();
            }
          };
          xhr.send();
        }
      };

      tick();
      setInterval(() => {
        tick();
      }, 1000);
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', event => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(section => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    /* PERF : sert de garde a CartDrawerItems.onCartUpdate() — le tiroir vient
       d'etre re-rendu, inutile d'aller rechercher la section une 2e fois. */
    window.lsfDrawerRenderedAt = Date.now();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  /*
   * PERF : la version heritee allait chercher `/cart?section_id=main-cart-items`
   * (l'ANCIENNE page panier) puis injectait son <cart-items> dans le tiroir.
   * Requete inutile a chaque ajout au panier + mauvaise cible.
   */
  onCartUpdate() {
    // Le tiroir vient d'etre re-rendu par product-form : rien a refaire.
    if (Date.now() - (window.lsfDrawerRenderedAt || 0) < 1500) return;

    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('.drawer__inner');
        const target = document.querySelector('cart-drawer .drawer__inner');
        if (source && target) {
          target.innerHTML = source.innerHTML;
          window.lsfDrawerHydrate();
        }
      })
      .catch(e => console.error(e));
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
